import { render, staticRenderFns } from "./event_tab_component_sale.vue?vue&type=template&id=117e9bc6&scoped=true&"
import script from "./event_tab_component_sale.vue?vue&type=script&lang=js&"
export * from "./event_tab_component_sale.vue?vue&type=script&lang=js&"
import style0 from "./event_tab_component_sale.vue?vue&type=style&index=0&id=117e9bc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117e9bc6",
  null
  
)

export default component.exports